/* istanbul ignore file */
/* eslint-disable no-self-compare */
/* eslint-disable eqeqeq */
import _ from 'underscore';

function isNaN(value) {
  return value !== null && (value != value || +value != value);
}

// Polyfill for cronparser component which is not published by us
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN#Polyfill
if (!_.has(Number, 'isNaN')) {
  _.extend(Number, { isNaN });
}
